import { render, staticRenderFns } from "./UpdateBar.vue?vue&type=template&id=3b21f732&"
import script from "./UpdateBar.vue?vue&type=script&lang=js&"
export * from "./UpdateBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports